import Select from "react-select";
import Label from "./label.jsx";

export default ({ label, labelStyle, style, ...rest }) => {
  return (
    <div style={style}>
      {label && <Label style={labelStyle}>{label}</Label>}
      <Select {...rest} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/select-field.jsx